var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_6433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 5.33337H5.33992M1.33325 3.46671L1.33325 6.44972C1.33325 6.77584 1.33325 6.9389 1.37009 7.09235C1.40275 7.2284 1.45663 7.35846 1.52973 7.47775C1.61219 7.61231 1.72749 7.72761 1.95809 7.95821L7.07051 13.0706C7.86254 13.8627 8.25856 14.2587 8.71522 14.4071C9.1169 14.5376 9.5496 14.5376 9.95129 14.4071C10.4079 14.2587 10.804 13.8627 11.596 13.0706L13.0705 11.5961C13.8625 10.8041 14.2586 10.4081 14.4069 9.95141C14.5375 9.54972 14.5375 9.11703 14.4069 8.71534C14.2586 8.25868 13.8625 7.86267 13.0705 7.07063L7.95809 1.95821C7.72749 1.72761 7.61219 1.61231 7.47763 1.52985C7.35833 1.45675 7.22828 1.40288 7.09223 1.37021C6.93878 1.33337 6.77572 1.33337 6.4496 1.33337L3.46659 1.33337C2.71985 1.33337 2.34648 1.33337 2.06127 1.4787C1.81038 1.60653 1.60641 1.8105 1.47858 2.06139C1.33325 2.3466 1.33325 2.71997 1.33325 3.46671ZM5.66659 5.33337C5.66659 5.51747 5.51735 5.66671 5.33325 5.66671C5.14916 5.66671 4.99992 5.51747 4.99992 5.33337C4.99992 5.14928 5.14916 5.00004 5.33325 5.00004C5.51735 5.00004 5.66659 5.14928 5.66659 5.33337Z",
    stroke: "#10B981",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_6433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon-tag.3d135077f693b0d8cf532ec9f3423bb1.svg";
export { ForwardRef as ReactComponent };